<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Form from 'general/components/form/email/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import Trustpilot from '../../components/trustpilot/Trustpilot.svelte';
    import Description from './description/Description.svelte';
    import ProductImage from '../../components/ProductImage/ProductImage.svelte';
    import Brands from '../../components/brands/Brands.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    let errorMessage: string;
</script>

<div class={s.main} style="margin-top: {$dyData.side.main?.marginTop || 0}">
    {#if $dyData.isLoadImage}
        <Description value={$dyData.description?.main} />
    {/if}
    {#if Array.isArray($dyData.side.main.image)}
        <div class={s.imagesWrapper} class:smallScreen={$dyData.isSmallerScreen}>
            {#each $dyData.side.main.image as image}
                <div class={s.imagesItem}>
                    <img class={s.images} src={image} alt={$dyData.side.main.alt} />
                </div>
            {/each}
            {#if $dyData.hasBrands}
                <Brands />
            {/if}
        </div>
    {:else if $dyData.isLoadImage}
        <ProductImage {instance} />
    {:else}
        <div class={s.imageContainer} class:bigImageContainer={$dyData.side.main.isBigImage}>
            <img class={s.image} src={$dyData.side.main.image} alt={$dyData.side.main.alt} />
        </div>
    {/if}
    {#if !$dyData.isLoadImage}
        <Description value={$dyData.description?.main} />
    {/if}

    <Form
        {instance}
        offerGiven={$dyData.offerGiven}
        template={TEMPLATE.SQUARE_DESKTOP_COMMON}
        marginBottom={errorMessage ? '26px' : '10px'}
        checkBoxMarginBottom={'8px'}
        bind:errorMessage
    />

    <Trustpilot side="main" />

    <Policy padding="0 25px" />
</div>
